import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ComboBox } from '@skbkontur/react-ui';
import { ValidationWrapper } from '@skbkontur/react-ui-validations';
import { FieldWrapper } from '../FieldWrapper';
export const RelationshipField = ({ validationInfo, onValueChange, relationshipList, value, disabled, labelClassName, width, }) => {
    const getItems = async (query) => {
        const items = relationshipList.filter((item) => item.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
        return items.map((item) => ({ value: item.code, label: item.name }));
    };
    const comboBoxValue = useMemo(() => {
        if (!value) {
            return null;
        }
        const relationshipType = relationshipList.find((item) => item.code === value);
        if (!relationshipType) {
            return null;
        }
        return {
            value,
            label: relationshipType.name,
        };
    }, [value, relationshipList]);
    const handleValueChange = (item) => {
        onValueChange(item.value);
    };
    const element = (_jsx(ComboBox, { width: width || 200, getItems: getItems, value: comboBoxValue, onValueChange: handleValueChange, onUnexpectedInput: (value) => {
            return { value: '', label: '' };
        }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430", "data-tid": 'staffWidget-relative-relationshipSelect', disabled: disabled }));
    return (_jsx(FieldWrapper, { label: "\u0421\u0442\u0435\u043F\u0435\u043D\u044C \u0440\u043E\u0434\u0441\u0442\u0432\u0430", labelClassName: labelClassName, children: validationInfo === undefined ? (element) : (_jsx(ValidationWrapper, { validationInfo: validationInfo, children: element })) }));
};
